import React from 'react'
import Marquee1 from "react-fast-marquee";
const ServicesMarquee = () => {
  return (
  <>
     <section className="sd-marquee pt-120 pb-10">
     <Marquee1 speed="60" direction="right" className="marquee-left">
                <h2 className="marquee-item">SOCIAL MEDIA </h2>
                <h2 className="marquee-item">COMMUNICATIONS </h2>
                <h2 className="marquee-item">EXPERIENCE DESIGN </h2>
                <h2 className="marquee-item">SOCIAL MEDIA MANAGEMENT </h2>
                <h2 className="marquee-item">STRATEGY </h2>
                <h2 className="marquee-item">BRANDING </h2>
                <h2 className="marquee-item">SOCIAL MEDIA MANAGEMENT </h2>
                <h2 className="marquee-item">WEB DESIGN </h2>
                <h2 className="marquee-item">ADVERTISING </h2>
                <h2 className="marquee-item">SOCIAL MEDIA </h2>
                <h2 className="marquee-item">COMMUNICATIONS </h2>
                <h2 className="marquee-item">Search Engine Optimisation (SEO) </h2>
                <h2 className="marquee-item">SOCIAL MEDIA MANAGEMENT </h2>
                <h2 className="marquee-item">Search Engine Marketing (PPC)</h2>
                <h2 className="marquee-item">Social Media Marketing Services (SMO/SMM)</h2>
                <h2 className="marquee-item">Influencer Marketing Services</h2>
                <h2 className="marquee-item">SOCIAL MEDIA MANAGEMENT </h2>
            </Marquee1>
        </section>
  </>
  )
}

export default ServicesMarquee
